<template>
  <div class="wrapper grid-x">
    <div class="cell small-12 medium-6" v-for="(textItems, index) in text" :key="'text-text:' + index">
      <v-text class="text-content" :class="{'-first': index === 0}" :text="textItems.text"/>
    </div>
  </div>
</template>

<script>
  import VText from './Text';

  export default {
    props: {
      text: Array
    },
    components: {
      VText
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .wrapper {
    margin: {
      top: vw-relative(40);
      bottom: vw-relative(40);
    }
  }
  .text-content {
    height: 100%;
    padding: vw-relative(20 0 0, 320);
    @include breakpoint(medium) {
      padding: vw-relative(0 80);
    }
    &.-first {
      @include breakpoint(small only) {
        padding: vw-relative(0 0 20, 320);
        border-bottom: 1px solid #737373;
      }
      @include breakpoint(medium) {
        border-right: 1px solid #737373;
      }
    }
  }
</style>
